import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {
  surveyUrl = environment.apiUrlV2+'/survey';
  constructor(private http: HttpClient) {}


  /**
   * Submit a new survey
   * @param data Survey data to submit
   */
  submitSurvey(data: any): Observable<any> {
    return this.http.post<any>(`${this.surveyUrl}`, data);
  }

  getStatus(): Observable<any> {
    return this.http.get<any>(`${this.surveyUrl}`);
  }
}